import $ from 'jquery';

import './_gtw-temporary-dialog.sass';

import {rusTimeDate, todayStart} from '../../../../../utils/time';

import '../../../../../mui/dialog';
import 'inputmask/dist/inputmask/inputmask.date.extensions';
import Inputmask from 'inputmask/dist/inputmask/inputmask';

export default (ui, device) => {
    const result = $.Deferred();

    const dialog = $(`
        <div class="ui-gtw-temporary-dialog">
            <h1 class="large">Временный режим</h1>
            
            <h2>установить режим</h2>
            <p>
                <select name="mode">
                    <option value="party"  >Вечеринка</option>
                    <option value="econom" >Эконом</option>
                    <option value="workday">Рабочий день</option>
                    <option value="weekend">Выходной день</option>
                </select>
            </p>
            
            <h2>до</h2>
            <p>
                <input type="text" name="until"/>
            </p>
        </div>
    `);

    dialog.find('[name="mode"]').val(device.gtw_mode()?.current);

    dialog
        .find('[name="until"]')
        .val(rusTimeDate(new Date(todayStart().getTime() + 24 * 60 * 60 * 1e3)));

    const until_field = dialog.find('[name="until"]');
    Inputmask('datetime', {
        mask: 'h:s 1.2.y',
        placeholder: 'чч:мм дд.мм.гггг',
        separator: '.',
    }).mask(until_field);

    dialog.mui_dialog({
        wide_padding: true,
        close: function () {
            if (result.state() === 'pending') result.reject();
            $(this).remove();
        },

        buttons: [
            {
                text: 'установить',
                click: function () {
                    const date_str = until_field.get(0).inputmask.unmaskedvalue();

                    result.resolve({
                        gtw_mode: {
                            current: dialog.find('[name="mode"]').val(),
                            old: device.gtw_mode()?.old,
                        },

                        gtw_temporary_end: {
                            hour: parseInt(date_str.substr(0, 2), 10),
                            minute: parseInt(date_str.substr(2, 2), 10),
                            second: 0,
                            day: parseInt(date_str.substr(4, 2), 10),
                            month: parseInt(date_str.substr(6, 2), 10),
                            year: parseInt(date_str.substr(8, 4), 10),
                        },
                    });

                    $(this).mui_dialog('close');
                },
            },
        ],
    });

    return result.promise();
};
